<script lang="ts" setup>
import { type Link, type Image } from '../types/types';

const props = defineProps<{
    firstCollection: {
        image: Image,
        link: Link
    },
    secondCollection: {
        image: Image,
        link: Link
    }
}>();
</script>
<template>
    <div class="cards-section">
      <div class="container-xl">
        <div class="cards-container">
            <div class="card-item">
                <div class="card-content">
                    <div class="card-image">
                        <NuxtImg v-if="firstCollection?.image?.node?.mediaItemUrl" :src="firstCollection?.image?.node?.mediaItemUrl" loading="lazy" format="webp"
                        :quality="80" :srcset="firstCollection?.image?.node?.srcSet" :alt="firstCollection?.image?.node?.title"/>
                    </div>
                    <div class="card-action w-100 d-flex justify-content-center">
                        <a target="_blank" :href="firstCollection?.link?.url" class="rounded-pill text-uppercase btn btn-green-light">
                            {{ firstCollection?.link?.title }}
                        </a>
                    </div>
                </div>
            </div>
            <div class="card-item">
                <div class="card-content">
                    <div class="card-image">
                        <NuxtImg v-if="secondCollection?.image?.node?.mediaItemUrl" :src="secondCollection?.image?.node?.mediaItemUrl" loading="lazy" format="webp"
                        :quality="80" :srcset="secondCollection?.image?.node?.srcSet" :alt="secondCollection?.image?.node?.title"/>
                    </div>
                    <div class="card-action w-100 d-flex justify-content-center">
                        <a target="_blank" :href="secondCollection?.link?.url" class="rounded-pill text-uppercase btn btn-green-light">
                            {{ secondCollection?.link?.title }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
</template>